<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="true"
        :scroll="{ x: '100%' }"
        :loading="loading"
      >
        <template slot="student" slot-scope="text, record">
          <strong>{{ record.student ? `${record.student.first_name} ${record.student.last_name}`.trim() : 'Unknown' }}</strong>
          <div class="text-muted font-size-12">
            <span v-if="record.student">{{ record.student.student_code }}</span>
            <span v-if="record.school_enrollment && record.school_enrollment.school_class"> · {{ record.school_enrollment.school_class.name }}</span>
            <span v-if="record.school_enrollment && record.school_enrollment.section"> / {{ record.school_enrollment.section.name }}</span>
          </div>
        </template>

        <template slot="program" slot-scope="text, record">
          {{ record.program ? record.program.name : 'N/A' }}
        </template>

        <template slot="session" slot-scope="text, record">
          <span v-if="record.tuition_session">{{ record.tuition_session.name }}</span>
          <span v-else class="text-muted"><i>All Sessions</i></span>
        </template>

        <template slot="dates" slot-scope="text, record">
          <div class="font-size-12">
            <div>Start: {{ record.start_date || 'N/A' }}</div>
            <div>End: {{ record.end_date || 'N/A' }}</div>
          </div>
        </template>

        <template slot="status" slot-scope="text">
          <span v-if="text === 'active'" class="badge badge-success">Active</span>
          <span v-else class="badge badge-danger">Inactive</span>
        </template>

        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <a-tooltip title="Edit Enrollment">
              <a href="javascript:;" class="btn btn-sm btn-light mr-2" @click="showEditModal(record)">
                <i class="fe fe-edit" />
              </a>
            </a-tooltip>
            <a-tooltip title="Delete Enrollment">
              <a href="javascript:;" class="btn btn-sm btn-danger" @click="onDelete(record)">
                <i class="fe fe-trash" />
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <edit-enrollment @onEdited="handleAfterEdit" />
  </div>
</template>

<script>
import EditEnrollment from '@/components/tuition/manage/enrollment/Edit'

const columns = [
  { title: 'Student', key: 'student', scopedSlots: { customRender: 'student' } },
  { title: 'Program', key: 'program', scopedSlots: { customRender: 'program' } },
  { title: 'Session', key: 'session', scopedSlots: { customRender: 'session' } },
  { title: 'Duration', key: 'dates', scopedSlots: { customRender: 'dates' } },
  { title: 'Status', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' } },
  { title: 'Actions', key: 'action', scopedSlots: { customRender: 'action' }, width: 120, className: 'text-right' },
]

export default {
  name: 'TuitionEnrollmentTable',
  components: { EditEnrollment },
  props: {
    loading: Boolean,
    data: { type: Array, default: () => [] },
  },
  data() {
    return { columns }
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openEditTuitionEnrollment', record)
    },
    handleAfterEdit() {
      this.$emit('updateTable')
    },
    onDelete(record) {
      this.$confirm({
        title: 'Delete Enrollment?',
        content: `Are you sure you want to remove this enrollment for student ID ${record.student_id}?`,
        okText: 'Yes, Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          this.$nprogress.start()
          this.$http.delete(`/api/tuition/enrollments/${record.id}`)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification.success({
                message: 'Deleted Successfully!',
                description: 'Enrollment has been removed.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
      })
    },
  },
}
</script>
